import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class DashboardService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getDashboardInfo(fundID) {
        const fundGlobalInfo = this.httpClient.get(
            `fund-presentation/funds/${fundID}/dashboard-information`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )

        const requestList = [fundGlobalInfo]

        return new Promise((resolve, reject) => {
            axios.all(requestList)
                .then(axios.spread((globalInfo) => {
                    resolve({
                        globalInfo: globalInfo
                    })
                })).catch(reject)
        })
    }
}